import React, { useEffect, useState } from 'react';
import './GelenCagriFilterModal.css';

const GelenCagriFilterModal = ({ isOpen, onClose, onApply, initialFilters, bugunStr, telefonGizle = false, tip = 'gelen' }) => {
  const [draft, setDraft] = useState(initialFilters);

  useEffect(() => {
    if (isOpen) {
      setDraft(initialFilters);
    }
  }, [isOpen, initialFilters]);

  if (!isOpen) return null;

  const setField = (key, value) => {
    setDraft((prev) => ({ ...prev, [key]: value }));
  };

  const handleApply = () => {
    if (draft.baslangic && draft.bitis && draft.baslangic > draft.bitis) {
      window.showNotification?.('error', 'Başlangıç tarihi bitiş tarihinden sonra olamaz.');
      return;
    }
    const min = draft.sureMin !== '' ? Number(draft.sureMin) : null;
    const max = draft.sureMax !== '' ? Number(draft.sureMax) : null;
    if (min != null && max != null && min > max) {
      window.showNotification?.('error', 'Minimum süre, maksimum süreden büyük olamaz.');
      return;
    }
    onApply({
      ...draft,
      telefon: (draft.telefon || '').trim(),
      sureMin: draft.sureMin === '' ? '' : String(Math.max(0, min || 0)),
      sureMax: draft.sureMax === '' ? '' : String(Math.max(0, max || 0)),
    });
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={onClose} role="presentation">
      <div
        className="modal-content gelen-cagri-filter-modal"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-labelledby="gelen-cagri-filter-title"
      >
        <div className="modal-header">
          <h2 id="gelen-cagri-filter-title">
            {tip === 'giden' ? 'Giden çağrı filtreleri' : 'Gelen çağrı filtreleri'}
          </h2>
          <button type="button" className="modal-close-btn" onClick={onClose} aria-label="Kapat">
            <i className="fas fa-times" aria-hidden />
          </button>
        </div>

        <div className="modal-body">
          <div className="gcf-section">
            <h3 className="gcf-section-title">Tarih aralığı</h3>
            <div className="gcf-row">
              <div className="form-group">
                <label htmlFor="gcf-baslangic">Başlangıç</label>
                <input
                  id="gcf-baslangic"
                  type="date"
                  value={draft.baslangic}
                  max={draft.bitis || bugunStr()}
                  onChange={(e) => setField('baslangic', e.target.value)}
                />
              </div>
              <div className="form-group">
                <label htmlFor="gcf-bitis">Bitiş</label>
                <input
                  id="gcf-bitis"
                  type="date"
                  value={draft.bitis}
                  min={draft.baslangic}
                  max={bugunStr()}
                  onChange={(e) => setField('bitis', e.target.value)}
                />
              </div>
            </div>
          </div>

          <div className="gcf-section">
            <h3 className="gcf-section-title">Çağrı bilgileri</h3>
            <div className="gcf-row">
              <div className="form-group">
                <label htmlFor="gcf-mesai">Mesai</label>
                <select
                  id="gcf-mesai"
                  value={draft.mesai}
                  onChange={(e) => setField('mesai', e.target.value)}
                >
                  <option value="">Tümü</option>
                  <option value="ici">Mesai içi</option>
                  <option value="disi">Mesai dışı</option>
                </select>
              </div>
              <div className="form-group">
                <label htmlFor="gcf-durum">Durum</label>
                <select
                  id="gcf-durum"
                  value={draft.durum}
                  onChange={(e) => setField('durum', e.target.value)}
                >
                  <option value="">Tümü</option>
                  <option value="cevaplandi">Cevaplandı</option>
                  <option value="cevapsiz">Cevapsız</option>
                </select>
              </div>
            </div>
          </div>

          <div className="gcf-section">
            <h3 className="gcf-section-title">Süre (saniye)</h3>
            <div className="gcf-row">
              <div className="form-group">
                <label htmlFor="gcf-sure-min">Minimum</label>
                <input
                  id="gcf-sure-min"
                  type="number"
                  min="0"
                  placeholder="Örn. 0"
                  value={draft.sureMin}
                  onChange={(e) => setField('sureMin', e.target.value)}
                />
              </div>
              <div className="form-group">
                <label htmlFor="gcf-sure-max">Maksimum</label>
                <input
                  id="gcf-sure-max"
                  type="number"
                  min="0"
                  placeholder="Örn. 120"
                  value={draft.sureMax}
                  onChange={(e) => setField('sureMax', e.target.value)}
                />
              </div>
            </div>
          </div>

          {!telefonGizle ? (
          <div className="gcf-section">
            <h3 className="gcf-section-title">Telefon</h3>
            <div className="form-group">
              <label htmlFor="gcf-telefon">{tip === 'giden' ? 'Aranan numara' : 'Arayan numara'}</label>
              <input
                id="gcf-telefon"
                type="tel"
                placeholder="5xx xxx xx xx"
                value={draft.telefon}
                maxLength={15}
                onChange={(e) => setField('telefon', e.target.value.replace(/[^\d+\s()-]/g, ''))}
              />
              <p className="gcf-hint">Kısmi numara ile arama yapabilirsiniz.</p>
            </div>
          </div>
          ) : null}
        </div>

        <div className="modal-footer">
          <button type="button" className="secondary-btn" onClick={onClose}>
            İptal
          </button>
          <button type="button" className="primary-btn" onClick={handleApply}>
            Uygula
          </button>
        </div>
      </div>
    </div>
  );
};

export default GelenCagriFilterModal;
